var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"display":"none"}},[_c('button',{attrs:{"id":"btn"},on:{"click":_vm.toMeiQia}})])}
var staticRenderFns = []

export { render, staticRenderFns }